<template>
  <v-container
    pl-0
    pr-0
  >
    <v-form ref="splitSegmentForm">
      <v-row
        v-if="showSplitSegment"
        class="justify-center"
      >
        <v-col
          cols="8"
          md="6"
        >
          <v-btn
            color="blue-grey darken-1"
            @click="splitSegment"
            dense
            dark
          >
            Split Segment
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-for="(split, index) in segmentSplit"
        :key="index"
      >
        <v-col
          cols="12"
          md="9"
        >
          <target-name
            :splitSegmentName="true"
            @updateName="val => (split.name = val)"
            @updateNameIsValid="val => updateSplitNameValid(index, val)"
          />
        </v-col>
        <v-col
          cols="6"
          md="2"
          class="pl-0 pr-0"
        >
          <v-text-field
            v-model="split.percentage"
            label="Split"
            type="number"
            suffix="%"
            @input="calculateTotal"
            dense
            hide-details="true"
          />
        </v-col>
        <v-col
          cols="12"
          md="1"
          class="pl-0 pr-0"
        >
          <v-btn
            icon
            @click="removeSplit(index)"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-if="!showSplitSegment"
        justify="end"
      >
        <v-alert
          :type="alert.type"
          dense
          text
        >
          {{ alert.message }}</v-alert
        >
      </v-row>
      <v-row
        v-if="!showSplitSegment"
        class="mt-0"
      >
        <v-col
          cols="12"
          sm="6"
        >
          <v-btn
            color="primary"
            @click="addSplit"
            dense
            text
            :disabled="totalPercentage >= 100"
          >
            <v-icon>mdi-plus-box-outline</v-icon>
            Add Split
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minLength, between, helpers } from 'vuelidate/lib/validators'
  import TargetName from '@/appComponents/targets/createTarget/components/TargetName'
  const MIN_PCT = 1
  const MAX_PCT = 99
  const TOTAL = 100
  const VALID_REGEX = /^[A-Za-z][A-Za-z0-9_]*$/

  export default {
    mixins: [validationMixin],
    components: {
      TargetName,
    },
    data() {
      return {
        valid: false,
        segmentSplit: [],
        totalPercentage: 0,
        alert: {
          type: 'error',
          message: 'Total percentage must equal 100%',
        },
        splitNameValid: [],
      }
    },
    validations: {
      segmentSplit: {
        required,
        minLength: minLength(2),
        $each: {
          name: { required, regex: helpers.regex('nameRegex', VALID_REGEX) },
          percentage: { required, between: between(MIN_PCT, MAX_PCT) },
        },
      },
    },
    computed: {
      showSplitSegment() {
        return this.segmentSplit.length === 0
      },
      isTotalValid() {
        return this.segmentSplit.length > 0 ? this.totalPercentage === TOTAL : true
      },
      isSplitSegmentsValid() {
        return this.segmentSplit.length > 0
          ? this.alert.type === 'success' && this.valid && !this.$v.$invalid && this.isTotalValid
          : true
      },
    },
    methods: {
      splitSegment() {
        this.segmentSplit = [{ name: '', percentage: MIN_PCT }]
        this.calculateTotal()
      },
      addSplit() {
        let remainingPercentage = TOTAL - this.totalPercentage
        this.segmentSplit.push({
          name: '',
          percentage: remainingPercentage,
        })
        this.calculateTotal()
      },
      removeSplit(index) {
        this.segmentSplit.splice(index, 1)
        this.calculateTotal()
      },
      calculateTotal() {
        this.totalPercentage = this.segmentSplit.reduce((total, split) => total + Number(split.percentage), 0)
      },
      setAlertMessage() {
        let validName = this.segmentSplit.every(split => VALID_REGEX.test(split.name))
        if (this.segmentSplit.some(split => split.percentage < MIN_PCT || split.percentage > MAX_PCT)) {
          this.alert = { type: 'error', message: `Percentage must be between ${MIN_PCT} and ${MAX_PCT}` }
        } else if (this.totalPercentage !== TOTAL) {
          this.alert = { type: 'error', message: `Total percentage: ${this.totalPercentage}%` }
        } else if (this.segmentSplit.some(split => split.name === null || split.name === '') || !validName) {
          this.alert = { type: 'error', message: 'Invalid Name' }
        } else if (this.checkForDuplicateSplitSegmentNames()) {
          this.alert = { type: 'error', message: 'Duplicate Name' }
        } else if (this.totalPercentage === TOTAL) {
          this.alert = { type: 'success', message: `Total percentage: ${this.totalPercentage}%` }
        }
      },
      checkForDuplicateSplitSegmentNames() {
        const nameCounts = this.segmentSplit.reduce((acc, segment) => {
          acc[segment.name] = (acc[segment.name] || 0) + 1
          return acc
        }, {})

        const duplicateNames = Object.keys(nameCounts).filter(name => nameCounts[name] > 1)
        return duplicateNames.length > 0
      },
      updateSplitNameValid(index, isValid) {
        this.$set(this.splitNameValid, index, isValid)
        this.valid = this.splitNameValid.every(isValid => isValid)
      },
    },
    watch: {
      segmentSplit: {
        deep: true,
        handler() {
          this.setAlertMessage()
          this.$emit('segmentSplit', this.segmentSplit)
        },
      },
      isSplitSegmentsValid: {
        immediate: true,
        handler(val) {
          this.$emit('valid', val)
        },
      },
    },
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// SegmentSplit.vue?3a96db6e